<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-confirm-dialog-panel tenga la fascia panna a filo del bordo
     inferiore. -->
<h2 mat-dialog-title>Conferma upload del file XML</h2>

<mat-dialog-content>
  <p class="izy-terms-message">
    Per inviare la Fattura al server devi accettare i termini del Servizio,
    disponibili al seguente link:
  </p>

  <!-- Il link ai termini e' un'azione secondaria: pillola bianca bordata nero,
       come nel dialog gemello di accettazione dei Termini in fase di invio.
       Apre in una scheda nuova, e l'icona lo dichiara. -->
  <button
    mat-stroked-button
    type="button"
    (click)="legalConditionsRedirect()"
    class="izy-button-ghost custom-button-border izy-terms-link">
    <mat-icon>open_in_new</mat-icon>
    Termini e condizioni
  </button>

  <p class="izy-terms-consent">
    Autorizzo IZY Srl al trattamento dei dati che sto per inviare. Confermo che
    le informazioni inserite sono veritiere e accetto i Termini e Condizioni:
  </p>

  <!-- La spunta obbligatoria in un riquadro a se', come nel dialog di conferma
       condiviso: e' il cancello dell'upload, non una riga di testo in mezzo al
       messaggio. -->
  <div class="izy-confirm-box izy-sharp-bl">
    <mat-checkbox [(ngModel)]="confirmed" color="primary">
      <span class="fw-bold">Confermo quanto riportato e accetto</span>
    </mat-checkbox>
  </div>

  <p class="izy-confirm-note">
    Nota: la fattura non viene inviata allo SDI, ma resta a disposizione sul tuo
    profilo per il calcolo di tasse, contributi e fatturato totale. Se il
    cliente presente nella fattura non esiste nella tua anagrafica, verrà creato
    in automatico.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Indietro
  </button>

  <button
    mat-raised-button
    matButton="filled"
    type="button"
    class="ms-2 izy-button-primary custom-button-border"
    [disabled]="!confirmed"
    (click)="confirm()">
    <mat-icon>check</mat-icon>
    Confermo
  </button>
</mat-dialog-actions>
